const Graphs2 = () => {
  return (
    <>
      <div className="fw-medium fs-5 my-3">Graphs:</div>

      <div className="bg-white p-3">
        <div>Engagement Rate by Platform:</div>
        <ul>
          <li>Stacked bar graph comparing engagement rates across different social media platforms.
          Reach and Impressions Over Time:</li>
          <li>Dual-axis line graph showing reach and impressions over time.
          Follower Growth Trend:</li>
          <li>Line graph depicting the growth of followers over time for each social media platform.</li>
        </ul>
      </div>
    </>
  )
}

export default Graphs2